import ParameterErrors from '../errors/ParameterErrors';
import getParentClass from '../core/getParentClass';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class ParameterValidation{
	static validateArray(arr, parameterName, expectedType, allowInheritance=false){
		if(arr ===undefined||arr===null)
			throwNotProvided(parameterName);
		if(!Array.isArray(arr))throwNotOfType('layers', 'Array');
		for(var i=0; i<arr.length; i++){
			const entry = arr[i];
			if(entry===undefined||entry===null){
				throw new Error(`Could not parse ${parameterName}. Entry at index ${i} was ${String(entry)}`);
			}
			const type = entry.constructor.name;
			if((!entry instanceof expectedType)&&((!allowInheritance)||(ParameterValidation._checkBaseTypes(entry, expectedType))))
				throw new Error(`Could not parse ${parameterName}. Entry at index ${i} was of type ${type}. It should be an instance of ${expectedType.constructor.name}`);
		}
	}
	static _checkBaseTypes(entry, expectedType){
		let currentParentClass = getParentClass(entry.constructor);
		while(currentParentClass!=null){
			if(currentParentClass instanceof expectedType)
				return true;
			currentParentClass = getParentClass(currentParentClass);
		}
		return false;
	}
}